import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { locStyle } from "@/lib/constants";

export const SummarySheet = ({ open, onOpenChange, catalog, counts }) => {
  const sectors = catalog?.sectors || {};

  const computeSector = (sector) => {
    const locs = sector.locations.map((l) => l.id);
    let total = 0;
    const byLoc = {};
    locs.forEach((l) => (byLoc[l] = 0));
    sector.products.forEach((p) => {
      locs.forEach((loc) => {
        const e = counts[`${p.id}~${loc}`];
        const q = e ? Number(e.quantity) || 0 : 0;
        byLoc[loc] += q;
        total += q;
      });
    });
    return { total: +total.toFixed(2), byLoc };
  };

  const grand = Object.values(sectors).reduce((acc, s) => acc + computeSector(s).total, 0);

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="bottom" data-testid="summary-sheet" className="rounded-t-3xl bg-card border-border max-h-[85vh] overflow-y-auto">
        <SheetHeader className="text-left">
          <SheetTitle className="font-display text-2xl font-extrabold">Récapitulatif</SheetTitle>
          <SheetDescription className="text-muted-foreground">Quantités totales comptées par secteur et salle.</SheetDescription>
        </SheetHeader>

        <div className="mt-4 rounded-2xl bg-primary/10 border border-primary/25 p-5 text-center">
          <div className="text-xs uppercase tracking-wider text-primary/80">Total unités (tous secteurs)</div>
          <div className="font-mono-num text-5xl font-extrabold text-primary mt-1" data-testid="summary-grand-total">
            {+grand.toFixed(2)}
          </div>
        </div>

        {Object.entries(sectors).map(([sid, sector]) => {
          const { total, byLoc } = computeSector(sector);
          return (
            <div key={sid} className="mt-5">
              <div className="flex items-center justify-between mb-2">
                <h4 className="font-display text-sm font-bold uppercase tracking-wider text-muted-foreground">{sector.label}</h4>
                <span className="font-mono-num text-base font-extrabold text-primary">{total}</span>
              </div>
              <div className="space-y-2">
                {sector.locations.map((loc) => {
                  const s = locStyle(loc.id);
                  const val = +byLoc[loc.id].toFixed(2);
                  const pct = total ? Math.round((val / total) * 100) : 0;
                  return (
                    <div key={loc.id} className="flex items-center gap-3">
                      <span className={`h-2.5 w-2.5 rounded-full ${s.dot}`} />
                      <span className="text-sm flex-1">{loc.label}</span>
                      <div className="w-24 h-1.5 rounded-full bg-secondary overflow-hidden">
                        <div className={`h-full ${s.dot}`} style={{ width: `${pct}%` }} />
                      </div>
                      <span className="font-mono-num text-sm font-bold w-12 text-right">{val}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </SheetContent>
    </Sheet>
  );
};
